import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-075ad570"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "img-box"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
  class: "article"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, "阅读详情 >", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "question",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.lookInfo(_ctx.articleItem))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    class: "Sketch",
    src: _ctx.articleItem.blogCoverPage,
    alt: _ctx.articleItem.blogTitle
  }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.articleItem.blogTime), 1), _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.articleItem.blogTitle), 1)]), _hoisted_6]);
}